module.exports = __webpack_public_path__ + "img/202104.2efd9679.png";